import { BarChart, Bar, LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { FONTS, COLORS } from "../constants/theme";

// ─── SalesIQ ───────────────────────────────────────────────────────────────────
// Persona: VP Sales
// Data sources: See constants/modules.js

const KPIs = [
  { label: "Quota Attainment", value: "87%", delta: "Team avg", color: "#d97706" },
  { label: "Win Rate", value: "62.7%", delta: "+4pts QoQ", color: "#059669" },
  { label: "Avg Deal Size", value: "$48K", delta: "+12% YoY", color: "#059669" },
  { label: "Sales Cycle", value: "42 days", delta: "-6 days QoQ", color: "#059669" },
  { label: "Pipeline Coverage", value: "3.4x", delta: "vs 3x min", color: "#059669" },
  { label: "Open Pipeline", value: "$7.6M", delta: "+23% QoQ", color: "#059669" }
];
const CHART_DATA = [
  {
    "stage": "Prospect",
    "value": 2800
  },
  {
    "stage": "Discovery",
    "value": 1900
  },
  {
    "stage": "Demo",
    "value": 1400
  },
  {
    "stage": "Proposal",
    "value": 820
  },
  {
    "stage": "Negotiation",
    "value": 460
  },
  {
    "stage": "Verbal",
    "value": 180
  }
];

export default function SalesIQ({ module: mod, theme }) {
  const { surface, border, text, muted, dark } = theme;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

      {/* KPI Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
        {KPIs.map((k, i) => (
          <div key={i} style={{ background: surface, border: `1px solid ${border}`, borderRadius: 12, padding: "16px 18px", position: "relative", overflow: "hidden" }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg, ${mod.accent}55, ${mod.accent})` }} />
            <p style={{ color: muted, fontSize: 10, fontFamily: FONTS.mono, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 6 }}>{k.label}</p>
            <p style={{ fontFamily: FONTS.display, fontWeight: 800, fontSize: 22, color: text, letterSpacing: "-.02em" }}>{k.value}</p>
            <span style={{ display: "inline-block", marginTop: 6, fontFamily: FONTS.mono, fontSize: 10, padding: "2px 7px", borderRadius: 20, color: k.color, background: k.color + "18" }}>{k.delta}</span>
          </div>
        ))}
      </div>

      {/* Chart */}
      <div style={{ background: surface, border: `1px solid ${border}`, borderRadius: 14, padding: "20px 24px" }}>
        <p style={{ fontFamily: FONTS.mono, fontSize: 11, color: muted, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 16 }}>Pipeline by Stage ($K)</p>
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={CHART_DATA} barGap={4}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1e243860" />
          <XAxis dataKey="stage" tick={{ fill: "#8892b0", fontSize: 11 }} />
          <YAxis tick={{ fill: "#8892b0", fontSize: 11 }} />
          <Tooltip contentStyle={{ background: "#0a0e1a", border: "1px solid #1e2438", borderRadius: 8, fontSize: 11 }} />
          
          <Bar dataKey="value" fill="#ea580c" radius={[4,4,0,0]} />
        </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Insight */}
      <div style={{ background: mod.accent + "10", border: `1px solid ${mod.accent}25`, borderRadius: 12, padding: "14px 18px", display: "flex", gap: 12, alignItems: "flex-start" }}>
        <span style={{ color: mod.accent, fontSize: 16, flexShrink: 0, marginTop: 1 }}>◉</span>
        <div>
          <p style={{ fontFamily: FONTS.mono, fontSize: 10, color: mod.accent, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 4 }}>IQ INSIGHT</p>
          <p style={{ fontSize: 13, color: dark ? "#a0aec0" : "#475569", lineHeight: 1.65 }}>Strong top-of-funnel but proposal-to-close conversion is the bottleneck — 42% of deals stall at negotiation.</p>
        </div>
      </div>
    </div>
  );
}
